export default __webpack_public_path__ + "static/footer-bg-4e1ae78b5347b23491b21781af704267.jpg";